import React from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {Link} from "react-router-dom";
import TooltipDelay from "components/TooltipDelay";

const SourceCol = ({source, source_uri, showLink = true}) => (
  <TooltipDelay title={t("incidents.table.source")} subtitle={source}>
    {showLink && source_uri ? (
      <AButton
        className="px-0 d-inline"
        component={Link}
        target="_blank"
        tertiary
        to={source_uri}>
        {source}
      </AButton>
    ) : (
      <span>{source}</span>
    )}
  </TooltipDelay>
);

SourceCol.propTypes = {
  source: PropTypes.string,
  source_uri: PropTypes.string,
  /**
   * Render as Link button or plain text (requires source_uri to be defined)
   */
  showLink: PropTypes.bool
};

export default SourceCol;
